module.exports = __webpack_public_path__ + "a8cfcb4f860d17b17aae7e3a83c2663e.pdf";